// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './QuoteTags.scss';

type Props = {
  tags: string[],
};

const QuoteTags = ({ tags }: Props) => (
  <div className="QuoteTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default QuoteTags;



// WEBPACK FOOTER //
// ./src/components/quote/QuoteTags/QuoteTags.js